import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { useAppContext } from "../../../context";

export default function ProductWorkflow({ product, productName }) {
  const { t } = useTranslation();
  const { language } = useAppContext();

  const productKey = {
    "group-saving": "ikimina",
    "u-save": "uSave",
    crowdfund: "crowdfund",
  }[productName];

  // Animation variants for cards
  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.2, duration: 0.7, ease: "easeOut" },
    }),
  };

  return (
    <div
      id="workflow"
      className="min-h-screen bg-white dark:bg-defaultBlack pt-16 px-4 sm:px-6 lg:px-8 dark:text-white"
    >
      <div className="container mx-auto px-4 pt-12">
        {/* Header Section */}
        <div className="mb-12">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-6 capitalize">
            {t("singleProductPage.common.workflowSection.title")}
          </h1>
          <p className="text-lg text-gray-600 dark:text-white/70">
            {t(`singleProductPage.${productKey}.workflowSection.title`)}
          </p>
        </div>

        {/* Main Content */}

        <div className="lg:flex lg:flex-row items-center gap-16">
          <div className="lg:w-1/2">
            <div className="space-y-6">
              {product.workflow.content.map((method, i) => (
                <motion.div
                  key={i}
                  className="flex items-start space-x-4 p-6 bg-white dark:bg-white/5 shadow-md rounded-lg  border border-defaultGray/10 min-w-full"
                  variants={cardVariants}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  custom={i}
                >
                  <div className="w-6 h-6 bg-defaultGreen/80 rounded-full flex-shrink-0 mt-1 text-white flex justify-center items-center font-bold">
                    {i + 1}
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2 uppercase flex flex-wrap items-center">
                      {t(
                        `singleProductPage.${productKey}.workflowSection.steps.${i}.title`
                      )}
                    </h3>
                    <p className="text-gray-600 dark:text-white/70">
                      {t(
                        `singleProductPage.${productKey}.workflowSection.steps.${i}.description`
                      )}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
          <motion.div
            className="lg:w-1/2 relative h-[600px] w-full overflow-hidden"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <img
              src={product.images.workflowImage[language]}
              alt={t(`singleProductPage.${productKey}.workflowSection.title`)}
              className="w-full h-full object-contain"
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
}
